import React from 'react' 
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper"
import projects from '../assets/projects'
import data from "../assets/projects"
import ProjectItem from './ProjectItem';
import "swiper/swiper-bundle.min.css"

SwiperCore.use([Navigation]);

export default function Projects() {
    return (
        <div id="projects" className="projects_section">
            <div className="container">
                <h1 style={{ textAlign:"center", marginBottom:"5px" }}>Projects</h1>
                 <div className="underline" style={{marginBottom:"30px"}}></div>
                <div className="projects_allItems">
                    <Swiper spaceBetween={30} slidesPerView={1} navigation
                        breakpoints = {
                            {
                                // when windows width is >= 640 px
                                640: {
                                    slidesPerView: 1,
                                },
                                768: {
                                    slidesPerView: 2,
                                },
                                1200: {
                                    slidesPerView: 3,
                                }
                            }
                        }
                    >
                        {projects.map((projects, index) => {
                            if(index >= 5) return;
                            return(
                                <SwiperSlide key={projects.id}>
                                    <ProjectItem title={projects.name} img={projects.img} desc={projects.desc} link={projects.link}/>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
            </div>
        </div>
    )
}
